import { CROPS } from './crops';
import { DECORATIONS } from './decorations';

export interface ShopEntry {
  itemId: string;
  price: number;
}

/** What Pip's Stall sells: seeds, decorations, and livestock. */
export function shopCatalog(): ShopEntry[] {
  const seeds: ShopEntry[] = Object.values(CROPS).map((c) => ({ itemId: c.seedItemId, price: c.seedPrice }));
  const decos: ShopEntry[] = Object.values(DECORATIONS)
    .filter((d) => !d.reward)
    .map((d) => ({ itemId: d.id, price: d.price }));
  const animals: ShopEntry[] = [
    { itemId: 'chicken', price: 300 },
    { itemId: 'duck', price: 350 },
    { itemId: 'sheep', price: 500 },
    { itemId: 'pig', price: 650 },
    { itemId: 'cow', price: 800 },
  ];
  const supplies: ShopEntry[] = [{ itemId: 'fertilizer', price: 40 }];
  return [...seeds, ...supplies, ...decos, ...animals];
}
